import React from 'react';
import moment from 'moment';
import RenderProfile from '../Profile';
import RenderProfilePicture from '../../_helpers/profile-picture';

export default function PatientCard({
  email = false,
  gender = false,
  lastName = false,
  firstName = false,
  profileUrl = false,
  dateOfBirth = false,
  phoneNumber = false,
  children
}) {

  return <div className='card border-0 axs-shadow axs-rounded'>
    <div className="card-body">
      
      {/* Mobile */}
      <div className='d-flex d-lg-none justify-content-around'>
        <div className="row w-100">
          <div className='d-flex'>
            {profileUrl &&
              <div className='col-auto my-auto'>
                <RenderProfilePicture width={50} height={50} image={profileUrl} circle cached={true} className='m-auto' />
              </div>
            }
            {firstName && lastName &&
              <div className="col-8 col-sm-auto my-auto">
                <div className="row">
                  <div className="col">
                    <b>{`${firstName} ${lastName}`}</b>
                  </div>
                </div>

                {dateOfBirth &&
                  <div className='row'>
                    <div className="col-auto my-auto">
                      <h6 className='m-0'>Date of Birth:</h6>
                    </div>
                    <div className="col-auto my-auto text-muted">
                      {moment(dateOfBirth).format('LL')}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      {/* Desktop */}
      <div className='d-none d-lg-block'>
        {profileUrl && firstName && lastName &&
          <RenderProfile profileUrl={profileUrl} name={`${firstName} ${lastName}`} type='Patient' />
        }
        <br />

        <div className="row">
          <div className="col">
            <h5 className='m-0'>Profile</h5>
          </div>
        </div>

        <hr className='my-3' />

        {dateOfBirth &&
          <div className="row">
            <div className="col">
              <h6>Date of Birth:</h6>
              <span className='text-muted'>{moment(dateOfBirth).format('LL')}</span>
            </div>
          </div>
        }

        {gender &&
          <div className="row mt-3">
            <div className="col">
              <h6>Gender:</h6>
              <span className='text-muted'>{gender === 'm' ? 'Male' : gender === 'f' ? 'Female' : 'Other'}</span>
            </div>
          </div>
        }

        {phoneNumber &&
          <div className="row mt-3">
            <div className="col">
              <h6>Phone Number:</h6>
              <span className='text-muted'>{phoneNumber}</span>
            </div>
          </div>
        }

        {email &&
          <div className="row mt-3">
            <div className="col">
              <h6>Email:</h6>
              <span className='text-muted'>{email}</span>
            </div>
          </div>
        }

        {children}
      </div>

    </div>
  </div>
}